import type { SVGProps } from 'react';
const SvgFunctions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#functions_svg__a)">
      <path
        fill="currentColor"
        d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4Z"
      />
    </g>
    <defs>
      <clipPath id="functions_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFunctions;
